import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GoArrowUp } from "react-icons/go";
import { cn } from "@/utils/utils";

const SHOW_AFTER_PX = 400;

/** User/admin dashboard areas — no floating back-to-top control. */
const HIDDEN_PREFIXES = ["/user", "/admin"];

export default function BackToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  const hidden = HIDDEN_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

  useEffect(() => {
    if (hidden) {
      setVisible(false);
      return;
    }

    const onScroll = () => {
      setVisible(window.scrollY > SHOW_AFTER_PX);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hidden]);

  if (hidden) return null;

  const scrollToTop = () => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
      className={cn(
        "fixed bottom-24 right-20 z-[9998] flex h-11 w-11 items-center justify-center rounded-full",
        "bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] p-[1.5px]",
        "shadow-[0_8px_28px_rgba(0,0,0,0.45)] transition-all duration-300",
        "hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#9ED473]",
        "md:bottom-22 md:right-28",
        visible
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0",
      )}
    >
      <span className="flex h-full w-full items-center justify-center rounded-full bg-[#0a0a0a] text-white">
        <GoArrowUp className="h-5 w-5" aria-hidden />
      </span>
    </button>
  );
}
